<template>
  <div
    class="d-flex flex-column primary"
    style="top: 0; bottom: 0; left: 0; right: 0; width: 100%; height: 100%;"
  >
    <v-row
      class="d-flex primary mr-n4"
      style="top: 0; bottom: 0; left: 0; right: 0; width: 100%; height: 100%;"
    >
      <v-col class="flex-grow-1" cols="1" style="min-width: 100px; max-width: 100%; padding: 0;">
        <v-img :src="backgroupImage" class="d-flex align-center" style="height: 100%">
          <div class="d-flex justify-center">
            <div
              class="d-flex flex-column login-logo-panel align-center justify-center py-12"
              style="height: 100px; width: 100px;"
            >
              <div class="d-flex mb-4">
                <div>
                  <v-img width="30" :src="logo"></v-img>
                </div>
                <div class="login-title white--text ml-2">{{$t('login.violy')}}</div>
              </div>
              <div class="d-flex">
                <v-img v-if="this.$i18n.locale == 'zh'" width="254" :src="login_title"></v-img>
                <v-img v-if="this.$i18n.locale == 'en'" width="450" :src="login_title"></v-img>
              </div>
              <div class="d-flex mt-auto"></div>

              <div v-if="this.$i18n.locale == 'zh' " class="white--text mb-2 login-text-content">
                <div
                    class="white--text login-subtitle mb-6"
                >{{$t("login.descriptions.want_add_own_sheet")}}</div>
                <div class="login-subtitle mb-2">{{$t("login.descriptions.no_problem")}}</div>
                <div class="login-subtitle-2 mb-2">{{$t("login.descriptions.in_creator")}}</div>
                <span class="login-subtitle-3">{{$t("login.descriptions.user_can_upload")}}</span>
                <span class="login-subtitle">{{` ${$t("login.descriptions.own_sheet")} `}}</span>
                <span class="login-subtitle-3">{{$t("login.descriptions.to_app")}}</span>
                <div class="login-subtitle-2">{{$t("login.descriptions.do_want")}}</div>
              </div>
              <div v-if="this.$i18n.locale == 'en' " class="white--text mb-2 login-text-content">
                  <span class="login-subtitle-2">Upload your own </span>
                  <span class="login-subtitle">SHEET MUSIC </span>
                  <span class="login-subtitle-2"> onto Violy App.</span>
                  <br>
                  <span class="login-subtitle">SHARE </span>
                  <span class="login-subtitle-2"> with your friends and practice TOGETHER!</span>
                  <br>
                  <span class="login-subtitle">CREATOR STUDIO,</span>
                  <br>
                  <span class="login-subtitle">all in Creative!</span>

                <!-- <span class="login-subtitle-3">{{`${$t("login.descriptions.in")} `}}</span>
                <span class="login-subtitle">{{$t("login.descriptions.creator")}}</span>
                <span
                  class="login-subtitle-3"
                >{{` ${$t("login.descriptions.can_upload_own_sheet")} `}}</span>
                <span class="login-subtitle">{{` ${$t("login.descriptions.sheet")} `}}</span>
                <span class="login-subtitle-3">{{$t("login.descriptions.to_violy")}}</span> -->
              </div>


            </div>
          </div>
        </v-img>
      </v-col>
      <v-col
        class="d-flex justify-center align-center ml-auto flex-grow-0 primary px-12"
        cols="5"
        style="min-width: 600px;"
      >
        <div class="white d-flex flex-column login-panel justify-center mr-12">
          <div class="d-flex mt-8 login-panel-header">
            <v-tabs class="login-mode-switch">
                <v-tab class="login-panel-subtitle" @click="changeLoginMode('email')">
                    {{this.$t('login.mobile_login_mode')}}
                </v-tab>
                <v-tab class="login-panel-subtitle" @click="changeLoginMode('mobile')">
                    {{this.$t('login.email_login_mode')}}
                </v-tab>
            </v-tabs>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  height="30"
                  depressed
                  rounded
                  text
                  class="ml-auto mr-10 mt-2"
                  v-on="on"
                >
                  <div class="mr-6 login-subtitle-2 primary--text">{{ currentLang }}</div>
                  <v-img :src="triangle" />
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in langList"
                  :key="index"
                  @click="changeLang(item)"
                >
                  <v-list-item-title class="normal-text">{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="input-container mt-8">
            <div class="login-panel-code d-flex mb-4"></div>
            <v-input
              height="76"
              :class="['text-input', 'd-flex', 'mb-5', posted && user_key.length == 0 ? 'text-input-error': '']"
              hideDetails
            >
              <v-menu offset-y v-if="loginMode == 'mobile'">
                <template v-slot:activator="{ on }">
                  <v-btn
                    height="30"
                    color="white"
                    text
                    left
                    class="white nation-code-btn"
                    v-on="on"
                  >
                    <div
                      class="download-title nation-code-container"
                    >{{ ($i18n.locale == "zh"? current_nation.name_zh : current_nation.name_en) + ' +' + current_nation.nation_code }}</div>
                    <v-img class="ml-n4" :src="nation_code_triangle" />
                  </v-btn>
                </template>
                <v-list height="400">
                  <v-list-item
                    v-for="(nation, index) in nation_codes"
                    :key="index"
                    @click="changeNation(nation)"
                    class="white"
                  >
                    <v-list-item-title
                      class="normal-text"
                    >{{ $i18n.locale == "zh"? nation.name_zh : nation.name_en + ' +' + nation.nation_code }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <input
                type="text"
                v-model="user_key"
                style="width: 240px;"
                :placeholder="loginMode == 'mobile' ? this.$t('login.mobile_input_placeholder'): this.$t('login.email_input_placeholder')"
              />

              <v-btn
                class="ml-auto input-remove-btn mr-4"
                fab
                width="19"
                height="19"
                @click="removeUsername"
                depressed
                color="transparent"
                rounded
              >
                <v-img :src="cancel_input_img" />
              </v-btn>
            </v-input>
            <v-input
              height="76"
              :class="['text-input', 'd-flex', 'mb-5', posted && auth_code.length == 0 ? 'text-input-error': '']"
              hideDetails
            >
              <input
                type="text"
                style="width: 150px;"
                v-model="auth_code"
                :placeholder="authcode_placeholder"
              />
              <div
                :class="{'primary--text': true, 'get-auth-code': true, 'ml-auto': true, 'mr-4': true, 'disable-get-auth-code': this.resend_seconds > 0}"
                @click="getAuthCode"
              >{{ this.resend_seconds > 0 ? `${this.resend_seconds} s ` + this.$t('login.last_can_resend') : this.$t('login.get_auth_code') }}</div>
            </v-input>

            <!-- <v-facebook-login
                app-id="177776412817787"
                :login={facebookLogined}
                ></v-facebook-login> -->
                <!-- 1474844362660474 -->

            <v-btn
              rounded
              height="52"
              color="primary login-input mt-4"
              width="100%"
              :loading="loading"
              @click="login"
            >{{this.$t('login.login')}}</v-btn>
          </div>
            <v-row class="d-flex mt-12 login-panel-footer">
                <v-col cols="6">
                    <div class="text download-title">{{ this.$t('login.login_with') }}</div>
                    <facebook-login class="button"
                        appId="1474844362660474"
                        loginLabel=""
                        @login="getFacebookUserData"
                        @logout="onFacebookLogout"
                        >
                        <!-- @get-initial-status="getFacebookUserData" -->
                        </facebook-login>
                </v-col>
                <v-col cols="6" style="height: 120px; bottom: 0;">
                    <div class="text download-title mb-1">{{this.$t('login.download_options')}}</div>
                    <v-card-actions class="justify-center">
                    <a class="mr-4 ml-2" :href="iOS_download_link" target="_blank">
                        <v-img :src="ios_download" />
                    </a>

                    <a :href="android_download_link" target="_blank">
                        <v-img :src="android_download" />
                    </a>
                    </v-card-actions>
                </v-col>
            </v-row>

        </div>
      </v-col>
    </v-row>
    <div v-if="isChina" style="height: 40px; bottom: 0;" class="white--text">
      <div class="d-flex justify-center align-center">
        <div>深圳市芒果未来科技有限公司</div>
        <div>版权所有 ©2017-2022</div>

        <a class="white--text" href="http://beian.miit.gov.cn/" target="_blank">粤ICP备18005775号</a>
        <a
          class="white--text align-center mx-2"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602002140"
        >
          <img :src="icp" />
        </a>
        <a
          class="white--text align-center"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602002140"
        >粤公网安备 44030602002140号</a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/LoginPanel.vue'
// import VFacebookLogin from 'vue-facebook-login-component';
// import facebookLogin from 'facebook-login-vuejs';
import facebookLogin from '../components/common/MFacebookLogin.vue'
// import { VFBLogin as VFacebookLogin } from 'vue-facebook-login-component';
import * as nationCodes from "../assets/nation_codes.json";
import * as commonNationCodes from "../assets/common_nation_codes.json";

export default {
  name: "home",
  components: {
    // VFacebookLogin: VFacebookLogin,
    facebookLogin
  },
  data: function() {
    const lan = this.$i18n.locale == "zh" ? "中文" : "English";
    // console.log('nationCodes', nationCodes.default);
    // nationCodes = [...nationCodes];
    const commonNation = ['China', 'United States', 'Singapore', 'United Kingdom',
    'South Korea', 'Mexico', 'Hong Kong(China)', 'Taiwan', 'Malaysia', 'Indonesia'];

    nationCodes.sort((item1, item2) => {
        return item1.name_en.localeCompare(item2.name_en)
    })
    // nationCodes.unshift(...commonNationCodes.default);
    const sortedNationCodes = nationCodes.default;
    sortedNationCodes.unshift(...commonNationCodes.default);

    console.log('nationCodes', nationCodes);
    const currentNation = nationCodes.find(nation => {
      return nation.nation_code == "86";
    });
    return {
      posted: false,
      loginMode: 'mobile',
      user_key: "",
      //   nation_code: "86",
      loading: false,
      auth_code: "",
      current_nation: currentNation,
      nation_codes: sortedNationCodes,
      timer: null,
      is_sent: false,
      resend_seconds: 0,
      currentLang: lan,
      langList: ["中文", "English"],
      logo: require("../assets/logo.svg"),
      icp: require("../assets/img/icp.png"),
      backgroupImage: require("../assets/img/backgrounp_left.svg"),
      login_panel_bg: require("../assets/img/login_panel_bg.svg"),
      ios_download: require("../assets/img/ios_download.svg"),
      android_download: require("../assets/img/android_download.svg"),
      cancel_input_img: require("../assets/img/cancel_username_img.svg"),
      triangle: require("../assets/img/triangle.svg"),
      nation_code_triangle: require("../assets/img/nation_code_triangle.svg"),
      left_quotation_mark: require("../assets/img/left_quotation_mark.svg"),
      right_quotation_mark: require("../assets/img/right_quotation_mark.svg"),
      login_backgrounp_img: require("../assets/img/login_backgrounp_img.png")
    };
  },
  computed: {
    isChina: function() {
      return window.location.host == "creator.17lianqin.cn";
    },
    login_title: function() {
      return this.$i18n.locale == "zh"
        ? require("../assets/img/title_logo_zh.svg")
        : require("../assets/img/title_logo_en.svg");
    },
    userkey_placeholder: function() {
      return this.$t("login.userkey_input_placeholder");
    },
    authcode_placeholder: function() {
      return this.$t("login.auth_code_input_placeholder");
    },
    keep_login_state_text: function() {
      return this.$t("login.keep_login_state");
    },
    iOS_download_link: function() {
      if (window.location.host == "creator.17lianqin.cn") {
        // "zh";
        return "https://itunes.apple.com/app/id1263079672";
      } else {
        // "en";
        return "https://itunes.apple.com/app/id1357516375";
      }
    },
    android_download_link: function() {
      if (window.location.host == "creator.17lianqin.cn") {
        // "zh";
        return "https://a.app.qq.com/o/simple.jsp?pkgname=cn.lianqinba.strings";
      } else {
        // "en";
        return "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.lianqinba.lian";
      }
    }
  },
  methods: {
    changeLoginMode: function(mode) {
        if (mode == 'mobile') {
            this.loginMode = 'email';
        } else {
            this.loginMode = 'mobile';
        }
    },
    getFacebookUserData: function(data) {
        console.log('facebook get facebook user data', data);
        const response = data.response;
        const authResponse = response.authResponse;

        if (!authResponse) {

            // this.$message({
            //     message: this.$t("login.msg.please_input_userkey"),
            //     type: "warning"
            //     });
        }
        // authResponse.userID = '2853222768277001'
        // authResponse.accessToken = 'EAAU9XPZAV2noBABkWJjw6P5k145sGdEZBUXs2EMj0ZCVLtiCO6XHjZBDoGpPvczHaIEvPEB1c6jHCNUpwp3bevyKP2JpenwrIZA4T4P2091Kz0E4NM72TiKVnqcE2MuGnkGVTxsJhFbWCWpeTk13n6YT0OVGYjoaySJn6vY2oa0Vvvm2bYTM36VLvyDVFuaDY3mo3Rg8elAZDZD'
        this.loading = true;
        this.$ajax
        .post(this.commonUtils.getRequestUrl("/login"), {
          user_key: authResponse.userID,
          auth_code: authResponse.accessToken,
          login_type: 'social',
          social_platform: 'facebook'
        })
        .then(
          function(response) {
            const result = response.data;
            if (result.success) {
              this.$store.commit("rememberUser", { user: result.user });
              this.$store.commit("toPage", { router_name: "albums" });
              this.$router.push({
                name: "albums"
              });
              this.commonUtils.initStoreData(this);
            }
            this.$message({
              message: this.$t("login.msg." + result.msg),
              type: result.success ? "success" : "warning"
            });
          }.bind(this)
        ).finally( function() { this.loading = false }.bind(this));
// authResponse:
// "EAAU9XPZAV2noBAJcXafpZCYh7eOf5KPVYz4qXu8uzvcAusYrcQGFB0Af2XgTn2gJeRxqvkwQKcApBDNjis7g2JaX6mbVZCXKkxUcFMwQ5nLCuDrgAtvVKcujnmMemvvADf4RybsliT28ZBCGZBRwNetYhGWIKmMjypiWeXKtVZAfuw5j6LAweiL6BhbPrUZAFrZCnaE67th8lgZDZD"
// accessToken: "EAAU9XPZAV2noBABkWJjw6P5k145sGdEZBUXs2EMj0ZCVLtiCO6XHjZBDoGpPvczHaIEvPEB1c6jHCNUpwp3bevyKP2JpenwrIZA4T4P2091Kz0E4NM72TiKVnqcE2MuGnkGVTxsJhFbWCWpeTk13n6YT0OVGYjoaySJn6vY2oa0Vvvm2bYTM36VLvyDVFuaDY3mo3Rg8elAZDZD"
// userID: "2853222768277001"
// expiresIn: 5619
// signedRequest: "WEyl2x_emkUIuvNr_vFRlouYmC67qbxIBrJtXs3s1Is.eyJ1c2VyX2lkIjoiMjg1MzIyMjc2ODI3NzAwMSIsImNvZGUiOiJBUURJM0RLNkJmLTJZaXpOVjRGQnZwb202OVY4a3hpLXRlRFdmRjBJbmRjREJIVWlpRWZ5OFliSEgtQlBzdnhRR2F0XzlveVJhUTNkcVBKMm5DY2NmLUx0a2hRV1NlWFpPOV90aDQyNmlWZHY1dWtDSVNTWlpwZjhreUhNSXRPb3hqS0ZJNUl1QVpaV0ptTmdab1ZDU3pwaWEyS2pQd1Z5YjBHbGZlcTVpNFliTFpTc3k2eEdzVHEyaGZxZXpack9DMFVmWVZRRWRwVWVkVzAxbnBudkJqWVg0RU9saHBydzlmdUoyc2lFLXVuOXMyejlGQ0dEalRFM3VXZ20wTzBIdm1DMWlHYWxkTlBRbGdOblpNX19hOEZsdXJ0OWxEMUhxbllObFRIQXZidEMyN1NrcFQwQ2pFbGhRZm1MZHJ5U3lZUnB1R1hfZ1Rwc0xhbk1ORUFfaTV3XyIsImFsZ29yaXRobSI6IkhNQUMtU0hBMjU2IiwiaXNzdWVkX2F0IjoxNTgxMDQyMzgxfQ"
// graphDomain: "facebook"
// data_access_expiration_time: 1588818381

    },
    onFacebookLogout: function(data) {
        console.log('facebook logout', data);


    },
    facebookLogined: function(event) {
        console.log('facebook logined', event);
    },
    changeLang: function(lang) {
      if (lang === "中文") {
        this.$i18n.locale = "zh";
      }
      if (lang === "English") {
        this.$i18n.locale = "en";
      }
      this.currentLang = lang;
    },
    changeNation: function(nation) {
      this.current_nation = nation;
    },
    getAuthCode: function() {
      if (this.resend_seconds > 0) return;
      if (!this.user_key || this.user_key.length == 0) {
        this.$message({
          message: this.$t("login.msg.please_input_userkey"),
          type: "warning"
        });
        return;
      }
      this.resend_seconds = 10;
      this.timer = setInterval(
        function() {
          if (this.resend_seconds > 0) {
            this.resend_seconds -= 1;
            console.log(this.resend_seconds);
          } else {
            console.log("clear interval");
            clearInterval(this.timer);
          }
        }.bind(this),
        1000
      );
      const url = this.commonUtils.getRequestUrl("/auth_code");
      this.loading = true;
      this.$ajax
        .post(url, {
          user_key: this.user_key,
          nation_code: this.current_nation.nation_code
        })
        .then(
          function(response) {

            const data = response.data;
            if (!data.success) {
              this.$message({
                message: this.$t("login.msg." + data.msg),
                type: "warning"
              });
              this.resend_seconds = -1;
              console.log("set this.resend_seconds -1");
            } else {
              this.$message({
                message: this.$t("login.msg.SENT"),
                type: "success"
              });
            }
          }.bind(this)
        ).finally( function() { this.loading = false }.bind(this));
    },

    login: function() {
      this.posted = true;

      if (this.user_key.length == 0) {
        this.$message({
          message: this.$t("login.msg.please_input_userkey"),
          type: "warning"
        });
        return;
      }

      if (this.auth_code.length == 0) {
        this.$message({
          message: this.$t("login.msg.please_input_auto_code"),
          type: "warning"
        });
        return;
      }
      this.loading = true;
      this.$ajax
        .post(this.commonUtils.getRequestUrl("/login"), {
          user_key: this.user_key,
          auth_code: this.auth_code,
          login_type: 'mobile_or_email'
        })
        .then(
          function(response) {
            const result = response.data;
            if (result.success) {
              this.$store.commit("rememberUser", { user: result.user });
              this.$store.commit("toPage", { router_name: "albums" });
              this.$router.push({
                name: "albums"
              });
              this.commonUtils.initStoreData(this);
            }
            this.$message({
              message: this.$t("login.msg." + result.msg),
              type: result.success ? "success" : "warning"
            });
          }.bind(this)
        ).finally( function() { this.loading = false }.bind(this));
    },
    removeUsername: function() {
      this.user_key = "";
    }
  }
};
</script>

<style scoped>
.back {
  height: 100%;
  width: 100%;
  display: block;
  background-size: cover;
}
.logo {
  height: 60px;
  width: 60px;
}
.text {
  /* text-align: center; */
}

.login-title {
  font-size: 20px;
  /* font-family: SHBold; */
  font-weight: bold;
}

.subtitle {
  font-size: 14px;
  /* font-family: SHBold; */
  font-weight: bold;
}

.input-container {
  /* width: 407px; */
  /* height: 424px; */
  padding-left: 60px;
  padding-right: 60px;
}
.login-panel {
  /* width: 90px; */
  /* height: 424px; */
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  max-width: 652px;
  min-width: 509px;
}

.login-panel-header {

    border-width: 0px;
    border-bottom-width: 1px;
    border-color: #D8D8D8;
    border-style: solid;

}
.login-panel-title {
  /* font-family: SHBold; */
  font-weight: bold;
  font-size: 40px;
}
.login-panel-subtitle {
  /* font-family: SHBold; */
  font-weight: bold;
  font-size: 20px;
}
.login-panel_img {
  width: 283px;
  height: 424px;
  padding-left: 39px;
  padding-right: 29px;
  margin-left: 16px;
}
.img-container {
  width: 283px;
  height: 424px;
  margin: 0;
  padding: 0;
}

.text-input {
  padding-left: 20px;
  font-size: 16px;
  height: 76px;
  border-width: 1px;

  border-color: #e3e3e3;
  border-style: solid;
  border-radius: 5px;
}
.text-input-error {
  border-color: #d74242 !important;
}

.get-auth-code {
  cursor: pointer;
  padding-left: 20px;
  border-width: 0px;
  border-left-width: 1px;
  border-color: #e3e3e3;
  border-radius: 0;
  background-color: transparent !important;
  border-style: solid;
}

button.white.nation-code-btn.v-btn.v-btn--flat.v-btn--left.v-btn--text.theme--light.v-size--default.white--text {
  padding-left: 0;
  text-transform: none !important;
}
.nation-code-container {
  cursor: pointer;
  left: 0;
  display: fixed;
  border-width: 0px;
  border-right-width: 1px;
  padding-right: 20px;
  border-color: #e3e3e3;
  border-radius: 0;
  border-style: solid;
}
.disable-get-auth-code {
  cursor: none;
  color: #999999 !important;
}
.login-input {
  font-size: 20px;
}
.row {
  display: inline-block;
}

.download-title {
  color: #848484;
}

div {
  /* font-family: SHRegular; */
  font-weight: normal;
  font-size: 16px;
}

.descript-1 {
  /* font-family: SHBold; */
  font-weight: bold;
}
.descript-2 {
  /* font-family: SHBold; */
  font-weight: bold;
  font-size: 20px;
}
.quotation-mark-container {
  margin-top: 40px;
  margin-left: 80px;
}
.login-panel_bg {
  padding-left: 18px;
  width: 370px;
}

.input-remove-btn {
  height: 19px;
  width: 19px;
}

.language {
  font-size: 14px;
}

.login-logo-panel {
  border-width: 1px;

  border-color: white;
  border-radius: 0;
  background-color: transparent !important;
  border-style: solid;
  min-width: 500px;
  min-height: 532px;
}
.login-subtitle {
  font-weight: 900;
  font-size: 20px;
}
.login-subtitle-2 {
  font-weight: 900;
  font-size: 14px;
}
.login-subtitle-3 {
  font-weight: normal;
  font-size: 14px;
}
.login-text-content {
  text-align: center;
}
.login-panel-footer {
    background-color: #D3E6FF;
    padding-left: 60px;
    padding-right: 60px;
}
.login-mode-switch {
    margin-left: 60px;
    width: 100px !important;
}
</style>
